import React, { useEffect, useState } from 'react';
import Topbar from '../components/Topbar';
import Sidebar from '../components/Sidebar';
import styles from '../assets/css/Dashboard.module.css';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

function Bhavan() {
  const navigate = useNavigate();
  const [bhavanList, setBhavanList] = useState([]);

  useEffect(() => {
    const fetchBhavanData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Bhaban_list`, {
          method: 'POST',
        });
        const data = await response.json();
        if (data.code === 1) {
          setBhavanList(data?.bhaban_list);
        }
      } catch (error) {
        console.error('Error fetching bhavan data:', error);
      }
    };
    fetchBhavanData();
  }, []);

  const handleViewReport = (bhaban_id, bhavan_name) => {
    navigate(`/bhavandetails/${bhaban_id}/${bhavan_name}`);
  };

  return (
    <>
      <Topbar/>
      <div className='d-flex'>
        <Sidebar/>
        <div className={styles.dashboardContainer}>
          <div className={styles.dashboardContent}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="mb-0" style={{ 
                color: '#2c3e50',
                fontWeight: '600',
                fontSize: '1.8rem'
              }}>Bhavan Management</h2>
            </div>
            
            <div className="row g-4">
              {bhavanList.map((bhavan, index) => (
                <motion.div 
                  key={bhavan.bhaban_id} 
                  className="col-md-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <div className="card h-100 border-0 shadow-lg" style={{
                    borderRadius: '15px',
                    overflow: 'hidden',
                    background: 'linear-gradient(145deg, #ffffff, #f8f9fa)'
                  }}>
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-4">
                        <div className="icon-wrapper" style={{
                          width: '60px',
                          height: '60px',
                          borderRadius: '12px',
                          // background: 'linear-gradient(45deg, #2196F3, #1976D2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '15px'
                        }}>
                          <img 
                            src={bhavan.icon} 
                            alt={bhavan.bhaban_name}
                            style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                          />
                        </div>
                        <div>
                          <h5 className="card-title mb-1" style={{
                            color: '#2c3e50',
                            fontWeight: '600'
                          }}>{bhavan.bhaban_name}</h5>
                          <p className="text-muted mb-0">{bhavan.about_us}</p>
                        </div>
                      </div>

                      <div className="row g-3 mb-4">
                        <div className="col-12">
                          <div className="stat-card p-3" style={{
                            background: 'rgba(33, 150, 243, 0.1)',
                            borderRadius: '10px'
                          }}>
                            <div className="d-flex align-items-center">
                              <FaMapMarkerAlt className="text-primary me-2" />
                              <p className="mb-0 text-muted">{bhavan.address}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end align-items-center">
                        <button 
                          className="btn btn-primary"
                          onClick={() => handleViewReport(bhavan.bhaban_id, bhavan?.bhaban_name)}
                          style={{
                            background: 'linear-gradient(45deg, #2196F3, #1976D2)',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '8px 20px'
                          }}
                        >
                          View Report
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Bhavan; 